module.exports = __webpack_public_path__ + "img/private.97f89d4b.svg";